import GoldenRockFooterComponent from "goldenrock/components/footer/golden-rock-footer-component";
import GoldenRockInit from "goldenrock/states/golden-rock-init";
import ModalTransition from "goldenrock/transitions/modal-transition";
import sgRecoverySpinRecordBuilder from "integration/builders/record/sg-recovery-spin-record-builder";
import sgRefreshRecordBuilder from "integration/builders/record/sg-refresh-record-builder";
import sgSpinRecordBuilder from "integration/builders/record/sg-spin-record-builder";
import sgFreespinComebackResultBuilder from "integration/builders/result/sg-freespin-comeback-result-builder";
import sgScatterResultBuilder from "integration/builders/result/sg-scatter-result-builder";
import expandedWildSupplement from "model/expanded-wild-supplement";
import rightToLeftWinsLastSupplement from "model/right-to-left-wins-last-supplement";
import recoveryRecordBuilder from "quickfire/integration/builders/record/recovery-record-builder";
import refreshRecordBuilder from "quickfire/integration/builders/record/refresh-record-builder";
import spinRecordBuilder from "quickfire/integration/builders/record/spin-record-builder";
import scatterResultBuilder from "quickfire/integration/builders/result/scatter-result-builder";
import quickfire, { QuickfirePaytablePayout } from "quickfire/quickfire";
import Quickfire from "quickfire/quickfire";
import QuickfireRecoverStake from "quickfire/states/quickfire-recover-stake";
import Components from "slotworks/components/components";
import ScreenShakeComponent from "slotworks/components/effects/screen-shake-component.ts";
import LinesComponent from "slotworks/components/lines/lines-component";
import GameLoop from "slotworks/core/game-loop";
import AnimationManager from "slotworks/graphics/animation/animation-manager";
import canvasManager from "slotworks/graphics/canvas/canvas-manager";
import ButtonElement from "slotworks/graphics/elements/button-element";
import Layers from "slotworks/graphics/layers/layers";
import { MultiStyleText } from "slotworks/graphics/pixi/pixi-multistyle-text";
import Gameplay from "slotworks/model/gameplay/gameplay";
import builderManager from "slotworks/server/builders/builder-manager";
import { Services } from "slotworks/services/services";
import SlotWorks from "slotworks/slotworks";
import ControlList from "slotworks/smart-ui/control-list";
import smartUiManager from "slotworks/smart-ui/smart-ui-manager";
import ShowWinLines from "slotworks/state-machine/standard/states/show-win-lines";
import SymbolCelebration from "slotworks/state-machine/standard/states/symbol-celebration";
import StateMachine from "slotworks/state-machine/state-machine";
import StateRegister from "slotworks/state-machine/state-register";
import { EnableOnScreenErrors } from "slotworks/utils/debug";
import deviceInfo from "slotworks/utils/device-info";
import Point from "slotworks/utils/geom/point";
import Logger from "slotworks/utils/logger";
import { SGPaytablePage1TextControl } from "smart-ui/controls/sg-paytable-page1-text-control";
import SGFreespinsRetriggered from "states/decisions/sg-freespins-retriggered";
import SGFreespinsTriggered from "states/decisions/sg-freespins-triggered";
import SGIsRecoveryFreespinsSummary from "states/decisions/sg-is-recovery-freespins-summary";
import SGRespinTriggered from "states/decisions/sg-respin-triggered";
import SGCombineWilds from "states/sg-combine-wilds";
import { SGEnterFreespins } from "states/sg-enter-freespins";
import SGExitFreespins from "states/sg-exit-freespins";
import SGExpandWilds from "states/sg-expand-wilds";
import { SGLoopWins } from "states/sg-loop-wins";
import SGRecoverFreespins from "states/sg-recover-freespins";
import { SGRespinCelebration } from "states/sg-respin-celebration";
import SGRetriggerFreespins from "states/sg-retrigger-freespins";
import SGShowWinLines from "states/sg-show-win-lines";
import { SGSpin } from "states/sg-spin";
import SGWinCycle from "states/sg-win-cycle";
import BigWinTextTransition from "transitions/big-win-text-transition";
import SGIdle from "./states/sg-idle";
import SGInit from "./states/sg-init";
import SgRequestSpin from "./states/sg-request-spin";
import FreespinsTriggerTransition from "./transitions/freespins-retrigger-transition";
import anticipationSupplement from "slotworks/model/gameplay/supplements/anticipation-supplement";
import sgAnticipationSupplement from "model/sg-anticipation-supplement";
import SgBetBarComponent from 'components/betbar/sg-bet-bar-component';
import SpinControl from 'slotworks/smart-ui/controls/spin/spin-control';
import SpinReelTransition from "slotworks/components/matrix/reel/transition-behaviours/spin/spin-reel-transition";

declare const __DEBUG__: boolean;
declare const require: any;
const assetConfig = require("./asset-config.json");
const gameConfig = require("./game-config.json");
const stateConfig = require("./state-config.json");
const soundConfig = require("./sound-config.json");
const componentConfig = require("./component-config.json");
const i18nConfig = require("./i18n-config.json");

/// if __DEBUG__
if (__DEBUG__) {
    Logger.useDefaults();
}
/// endif

const configure = () => {

    if (deviceInfo.isDesktop) {
        canvasManager.setPortraitEnabled(false);
    }

    ScreenShakeComponent.shakeDomBackground = true;

    MultiStyleText.renderAtFullResolution = false;

    ButtonElement.DISABLED_TINT = 0x6A6C6E;

    SpinControl.SPACE_TO_SKIP = false;

    SpinReelTransition.allowAnticipationSkips = false;

    Components.BetBarComponentType = SgBetBarComponent;

    Components.FooterComponentType = GoldenRockFooterComponent;

    canvasManager.FULLSCREEN_IN_IFRAME = false;

    Quickfire.menuExclusions.push("spin");

    GoldenRockInit.SETTINGS_LAYERS.splice(GoldenRockInit.SETTINGS_LAYERS.indexOf(Layers.Banners), 1);

    Gameplay.dataProcessorSupplements.addBeforeStandard(expandedWildSupplement);
    Gameplay.dataProcessorSupplements.addAfterStandard(rightToLeftWinsLastSupplement);
    Gameplay.dataProcessorSupplements.remove(anticipationSupplement);
    Gameplay.dataProcessorSupplements.addAfterStandard(sgAnticipationSupplement);

    ShowWinLines.PER_LINE_DELAY = 250;
    ShowWinLines.END_DELAY = 500;

    ShowWinLines.ENABLE_BEHAVIOUR_EFFECTS = true;
    ShowWinLines.ENABLE_LINE_EFFECTS = true;

    ShowWinLines.DEFAULT_TINT_COLOR = 0xFFD67D;
    ShowWinLines.LINE_COLORS = [
        0xC0FFB2,
        0xA7FFF6,
        0x6882B8,
        0xDF91FF,
        0xFF9FAD,
        0xC0FFB2,
        0xA7FFF6,
        0x6882B8,
        0xDF91FF,
        0xFF9FAD,
        0xC0FFB2,
        0xA7FFF6,
        0x6882B8,
        0xDF91FF,
        0xFF9FAD,
        0xC0FFB2,
        0xA7FFF6,
        0x6882B8,
        0xDF91FF,
        0xFF9FAD
    ];

    setupFonts();
};

const setupFonts = () => {
    const langs: string[] = ["cs", "hr", "hu", "lv", "lt", "pl", "sk", "sl", "tk", "el", "tr"];
    Services.onInit.addOnce(() => {
        Services.translations.setFontSubstitute("copenhagen-regular", { font: "arial", includedLanguages: [...langs, "vi", "ro"] });
        Services.translations.setFontSubstitute("copenhagen-semibold", { font: "arial", includedLanguages: [...langs, "vi", "ro"] });
        Services.translations.setFontSubstitute("copenhagen-light", { font: "arial", includedLanguages: [...langs, "vi", "ro"] });
        Services.translations.setFontSubstitute("copenhagen-bold", { font: "arial-black", includedLanguages: langs });
        Services.translations.setFontSubstitute("copenhagen-bold", { font: "arial", includedLanguages: ["vi", "ro"] });
    });
};

const setupComms = () => {
    builderManager.removeRecordBuilder(refreshRecordBuilder);
    builderManager.removeRecordBuilder(spinRecordBuilder);
    builderManager.removeRecordBuilder(recoveryRecordBuilder);

    builderManager.removeResultBuilder(scatterResultBuilder);

    builderManager.addRecordBuilder(sgRefreshRecordBuilder);
    builderManager.addRecordBuilder(sgSpinRecordBuilder);
    builderManager.addRecordBuilder(sgRecoverySpinRecordBuilder);

    builderManager.addResultBuilder(sgScatterResultBuilder);
    builderManager.addResultBuilder(sgFreespinComebackResultBuilder);
};

const setupStates = () => {
    StateRegister.add("freespin-retrigger-celebration", new SymbolCelebration(StateMachine, "FRE"));

    // Add states here
    StateRegister.add("quickfire-recover-stake", new QuickfireRecoverStake(StateMachine));
    StateRegister.add("sg-init", new SGInit(StateMachine));
    StateRegister.add("sg-idle", new SGIdle(StateMachine));
    StateRegister.add("sg-request-spin", new SgRequestSpin(StateMachine));
    StateRegister.add("sg-spin", new SGSpin(StateMachine));
    StateRegister.add("sg-retrigger-freespins", new SGRetriggerFreespins(StateMachine));
    StateRegister.add("sg-recover-freespins", new SGRecoverFreespins(StateMachine));
    StateRegister.add("sg-enter-freespins", new SGEnterFreespins(StateMachine));
    StateRegister.add("sg-exit-freespins", new SGExitFreespins(StateMachine));

    StateRegister.add("sg-show-win-lines", new SGShowWinLines(StateMachine));
    StateRegister.add("sg-win-cycle", new SGWinCycle(StateMachine));
    StateRegister.add("sg-loop-wins", new SGLoopWins(StateMachine));

    StateRegister.add("sg-expand-wilds", new SGExpandWilds(StateMachine));
    StateRegister.add("sg-combine-wilds", new SGCombineWilds(StateMachine));

    StateRegister.add("sg-freespins-triggered", new SGFreespinsTriggered());
    StateRegister.add("sg-freespins-retriggered", new SGFreespinsRetriggered());
    StateRegister.add("sg-is-recovery-freespins-summary-check", new SGIsRecoveryFreespinsSummary());

    // Respins
    StateRegister.add("sg-respin-triggered", new SGRespinTriggered());
    StateRegister.add("sg-respin-celebration", new SGRespinCelebration(StateMachine));
};

const setupTransitions = () => {
    Layers.CelebrationContent.setTransitions("bigWin", new BigWinTextTransition(null, "bigWin"));
    Layers.CelebrationContent.setTransitions("megaBigWin", new BigWinTextTransition(null, "megaBigWin"));
    Layers.CelebrationContent.setTransitions("hugeBigWin", new BigWinTextTransition(null, "hugeBigWin"));
    Layers.Prompts.setTransitions("freespinsretrigger", new FreespinsTriggerTransition(null));
    Layers.Prompts.setTransitions("freespinswin", new ModalTransition(Layers.Prompts, 400));
    Layers.Prompts.setTransitions("freespinssummary", new ModalTransition(Layers.Prompts, 400));
};

const setupComponents = () => {
    const landscapeOffset = new Point(0, 10);
    const portraitOffset = new Point(0, -260);
    canvasManager.useFixedPositionBackground(landscapeOffset, portraitOffset);

    LinesComponent.lineFlips.set(4, new Point(0, 1));
    LinesComponent.lineFlips.set(6, new Point(0, 1));
    LinesComponent.lineFlips.set(8, new Point(0, 1));
    LinesComponent.lineFlips.set(9, new Point(0, 1));
};

const setupSmartUI = () => {
    if (deviceInfo.isDesktop) {
        const paytableSmartUIGroup = smartUiManager.newSmartUIGroup(Layers.PaytableContent, "page_1");
        Layers.MenusContent.onSceneEnter.add((scene: string) => {
            if (scene === "paytable") {
                paytableSmartUIGroup.show().execute();
            } else {
                paytableSmartUIGroup.hide();
            }
        });
    }

    ControlList.addControlList(new ControlList<SGPaytablePage1TextControl>(
        SGPaytablePage1TextControl,
        "pt1_description"
    ));
};

const ready = () => {
    setupTransitions();

    if (__DEBUG__) {
        GameLoop.showStats();
    }

    canvasManager.setPortraitCanvasEnabled(true);
    // Design doesn't work well on 4:3 aspect devices, e.g iPad. Offset the canvas to fit, dropping off the volcano
    if (deviceInfo.isIpad()) {
        canvasManager.setPortraitScale(1, new Point(0.5, 0.31), new Point(0, -0.11));
    } else if (deviceInfo.isAppleDevice()) {
        canvasManager.setPortraitScale(1, new Point(0.5, 0.23), new Point(0, -0.15));
    } else {
        canvasManager.setPortraitScale(1, new Point(0.5, 0.08));
    }
};

quickfire.paytable.set("0", new QuickfirePaytablePayout(0, "5S1", 0));
quickfire.paytable.set("1", new QuickfirePaytablePayout(0, "4S1", 0));
quickfire.paytable.set("2", new QuickfirePaytablePayout(0, "3S1", 0));
quickfire.paytable.set("3", new QuickfirePaytablePayout(1, "5S2", 0));
quickfire.paytable.set("4", new QuickfirePaytablePayout(1, "4S2", 0));
quickfire.paytable.set("5", new QuickfirePaytablePayout(1, "3S2", 0));
quickfire.paytable.set("6", new QuickfirePaytablePayout(2, "5S3", 0));
quickfire.paytable.set("7", new QuickfirePaytablePayout(2, "4S3", 0));
quickfire.paytable.set("8", new QuickfirePaytablePayout(2, "3S3", 0));
quickfire.paytable.set("9", new QuickfirePaytablePayout(3, "5S4", 0));
quickfire.paytable.set("10", new QuickfirePaytablePayout(3, "4S4", 0));
quickfire.paytable.set("11", new QuickfirePaytablePayout(3, "3S4", 0));
quickfire.paytable.set("12", new QuickfirePaytablePayout(4, "5S5", 0));
quickfire.paytable.set("13", new QuickfirePaytablePayout(4, "4S5", 0));
quickfire.paytable.set("14", new QuickfirePaytablePayout(4, "3S5", 0));
quickfire.paytable.set("15", new QuickfirePaytablePayout(5, "5S6", 0));
quickfire.paytable.set("16", new QuickfirePaytablePayout(5, "4S6", 0));
quickfire.paytable.set("17", new QuickfirePaytablePayout(5, "3S6", 0));
quickfire.paytable.set("18", new QuickfirePaytablePayout(6, "5S7", 0));
quickfire.paytable.set("19", new QuickfirePaytablePayout(6, "4S7", 0));
quickfire.paytable.set("20", new QuickfirePaytablePayout(6, "3S7", 0));
quickfire.paytable.set("21", new QuickfirePaytablePayout(0, "5S1", 0));
quickfire.paytable.set("22", new QuickfirePaytablePayout(1, "5S2", 0));
quickfire.paytable.set("23", new QuickfirePaytablePayout(2, "5S3", 0));
quickfire.paytable.set("24", new QuickfirePaytablePayout(3, "5S4", 0));
quickfire.paytable.set("25", new QuickfirePaytablePayout(4, "5S5", 0));
quickfire.paytable.set("26", new QuickfirePaytablePayout(5, "5S6", 0));
quickfire.paytable.set("27", new QuickfirePaytablePayout(6, "5S7", 0));
quickfire.paytable.set("28", new QuickfirePaytablePayout(0, "4S1", 0));
quickfire.paytable.set("29", new QuickfirePaytablePayout(0, "3S1", 0));
quickfire.paytable.set("30", new QuickfirePaytablePayout(1, "4S2", 0));
quickfire.paytable.set("31", new QuickfirePaytablePayout(1, "3S2", 0, true, 10));
quickfire.paytable.set("32", new QuickfirePaytablePayout(2, "4S3", 0, true, 10));
quickfire.paytable.set("33", new QuickfirePaytablePayout(2, "3S3", 0, true, 10));
quickfire.paytable.set("34", new QuickfirePaytablePayout(3, "4S4", 0, true, 10));
quickfire.paytable.set("35", new QuickfirePaytablePayout(3, "3S4", 0, true, 10));
quickfire.paytable.set("36", new QuickfirePaytablePayout(4, "4S5", 0, true, 10));
quickfire.paytable.set("37", new QuickfirePaytablePayout(4, "3S5", 0, true, 10));
quickfire.paytable.set("38", new QuickfirePaytablePayout(5, "4S6", 0, true, 10));
quickfire.paytable.set("39", new QuickfirePaytablePayout(5, "3S6", 0, true, 10));
quickfire.paytable.set("40", new QuickfirePaytablePayout(6, "4S7", 0, true, 10));
quickfire.paytable.set("41", new QuickfirePaytablePayout(6, "3S7", 0, true, 10));
quickfire.paytable.set("42", new QuickfirePaytablePayout(8, "FS2Trigger", 0, true));
quickfire.paytable.set("43", new QuickfirePaytablePayout(7, "FS1Trigger", 0, false));
quickfire.paytable.set("44", new QuickfirePaytablePayout(7, "FS1Retrigger", 0, false));
quickfire.paytable.set("45", new QuickfirePaytablePayout(8, "FS2Retrigger", 0, true));
quickfire.paytable.set("46", new QuickfirePaytablePayout(7, "FS2WildLand", 0));

quickfire.start(
    () => {
        configure();
        setupSmartUI();
        setupComponents();
        setupComms();
        setupStates();
    },
    (callback) => {
        SlotWorks.go(gameConfig, stateConfig, assetConfig, componentConfig, soundConfig, i18nConfig, callback);
    },
    () => ready()
);

/// if __DEBUG__
if (__DEBUG__) {
    EnableOnScreenErrors();
}
/// endif
